import {ChannelType} from "./../../../channel/~store/models/enums/ChannelType"

export const GetChannelImage = (type: ChannelType): string | undefined => {
    switch(type) {
        case ChannelType.Telegram: return (require("src/app/shared/images/Chat/telegram.svg").default);
        case ChannelType.Viber: return (require("src/app/shared/images/Chat/viber.svg").default);
        case ChannelType.Vk: return (require("src/app/shared/images/Chat/vk.svg").default);
        case ChannelType.Widget: return (require("src/app/shared/images/Chat/widget.svg").default);
        case ChannelType.Facebook: return (require("src/app/shared/images/Chat/facebook.svg").default);
        case ChannelType.WeChat: return (require("src/app/shared/images/Chat/wechat.svg").default);
        case ChannelType.Instagram: return (require("src/app/shared/images/Chat/instagram.svg").default);
        case ChannelType.UniformWidget: return (require("src/app/shared/images/Chat/uniformwidget.svg").default);
        case ChannelType.EdnaWhatsApp: return (require("src/app/shared/images/Chat/whatsapp-logo.svg").default);
        case ChannelType.WhatsApp: return (require("src/app/shared/images/Chat/whatsapp-logo.svg").default);
        case ChannelType.VoiceChannel: return (require("src/app/shared/images/Chat/voice-channel-logo.svg").default);
        case ChannelType.TelegramPrivate: return require("src/app/shared/images/Chat/telegram_private.svg").default;
        case ChannelType.SendPulse: return require("src/app/shared/images/Chat/sendPulse.svg").default;
    }
}